import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const WrapperT1 = styled.div`
  padding: 15px;
  border-bottom: 1px solid #b1caf6;
  &:last-of-type {
    border-bottom: 0px;
  }
`;
export const WrapperT2 = styled.div`
  width: 100%;
`;
